import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=5662bc0f&scoped=true&"
import script from "./GoogleLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleLogin.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=5662bc0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662bc0f",
  null
  
)

export default component.exports